import Vue from "vue";
import ExportDialogContent from "./ExportDialogContent.vue";
export default Vue.extend({
    data() {
        return {
            animationSettings: { effect: "None" },
            contentTemplate: function () {
                return {
                    template: ExportDialogContent
                };
            }
        };
    },
    methods: {
        show(filters) {
            // The content sets the filters before the dialog is shown
            this.$emit("show", filters);
            this.$refs.paymentsExportDialog.show();
        },
        hide() {
            this.$refs.paymentsExportDialog.hide();
        }
    }
});
